import Obstacle from './objects/Obstacle';

export default class GameLayer extends Phaser.Group {
  constructor(game, levelRef, data, screenH) {
    super(game);

    this.levelRef = levelRef;
    this.data = data;
    this.ground = data.ground;
    this.layerH = data.height;
    this.screenH = screenH;

    //
    this.obstacles = [];
    this.pickups = [];
    this.obstaclesGroup = this.game.make.group();
    this.addChild(this.obstaclesGroup);

    //
    this.heroesGroup = this.game.make.group();
    this.addChild(this.heroesGroup);

    //
    this.distanceToObstacle = 100; // distance to place next obstacle / pickup
  }

  setScreenHeight(value) {
    this.screenH = value;
  }

  addHero(hero) {
    this.hero = hero;
    this.hero.shadow = this.game.make.image(hero.x, hero.y, 'chasegame_shadow');
    this.hero.shadow.anchor.set(0.5);

    this.addChildAt(hero.shadow, 0);
    this.heroesGroup.addChild(hero);
  }

  addFollower(follower) {
    follower.shadow = this.game.make.image(follower.x, follower.y, 'chasegame_shadow');
    follower.shadow.anchor.set(0.5);

    this.addChildAt(follower.shadow, 0);
    this.heroesGroup.addChild(follower);
  }

  addVillain(villain) {
    villain.shadow = this.game.make.image(villain.x, villain.y, 'chasegame_shadow');
    villain.shadow.anchor.set(0.5);

    this.addChildAt(villain.shadow, 0);
    this.addChild(villain);
  }

  sortHeroes() {
    let heroes = this.heroesGroup.getAll();
    heroes.sort((a, b) => (a.depth > b.depth ? 1 : a.depth < b.depth ? -1 : 0));
    this.heroesGroup.removeAll();
    for (let i = 0; i < heroes.length; i++) {
      this.heroesGroup.addChild(heroes[i]);
    }
  }

  step(dt, timeLeft) {
    this.timeLeft = timeLeft;
    for (let i = 0; i < this.obstacles.length; i++) {
      this.obstacles[i].step(this.hero, dt);
    }
    // for (let i = 0; i < this.pickups.length; i++) {
    //   this.pickups[i].step(this.hero, dt);
    // }
  }

  scroll(dx, y) {
    //move obstacles
    for (let i = 0; i < this.obstacles.length; i++) {
      let obstacle = this.obstacles[i];
      obstacle.x -= dx;

      //remove obstacle if out of the screen
      if (obstacle.x < -obstacle.width) {
        this.obstacles.splice(i, 1);
        this.obstaclesGroup.removeChild(obstacle);
        obstacle.destroy();
        i--;
      }
    }

    //move pickups
    // for (let i = 0; i < this.pickups.length; i++) {
    //   let pickup = this.pickups[i];
    //   pickup.x -= dx;
    //
    //   //remove not collected pickups if out of the screen
    //   if (!pickup.isCollected && pickup.x < -pickup.width) {
    //     this.pickups.splice(i, 1);
    //     this.obstaclesGroup.removeChild(pickup);
    //     pickup.destroy();
    //     i--;
    //   }
    // }

    //add obstacle
    this.distanceToObstacle -= dx;
    if (this.distanceToObstacle <= 0 && this.timeLeft > 4) {
      this.addObstacle();
    }

    //
    this.y = -y * (this.layerH - this.screenH);
  }

  addObstacle() {
    // distance depends on current speed
    this.distanceToObstacle = 1200 + 400 * Math.random();

    let id;
    do {
      id = (this.data.obstacles.length * Math.random()) | 0;
    } while (this.lastObstId == id);
    this.lastObstId = id;

    let obst = new Obstacle(this.game, this, 1680, this.ground, this.data.obstacles[id]);

    this.obstaclesGroup.addChildAt(obst, 0);
    this.obstacles.push(obst);
  }

  // addPickup(x, y) {
  //   let pickup = new Pickup(this.game, x, y, this.game.common.heroId);
  //   pickup.onCollect.add(this.onCollectPickup, this);
  //   pickup.onHide.add(this.onHidePickup, this);
  //   this.obstaclesGroup.addChild(pickup);
  //   this.pickups.push(pickup);
  // }
  //
  // onCollectPickup(pickup) {
  //   this.levelRef.playRef.collectPickup();
  // }
  //
  // onHidePickup(pickup) {
  //   let ind = this.pickups.indexOf(pickup);
  //   this.pickups.splice(ind, 1);
  //   this.obstaclesGroup.removeChild(pickup);
  //   pickup.destroy();
  // }
  //
  // vanishPickups() {
  //   for (let i = 0; i < this.pickups.length; i++) {
  //     this.pickups[i].vanish();
  //   }
  // }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/GameLayer.js